import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanEditDriver = (): boolean => {
  const [canEditDriver, setCanEditDriver] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editAllPermission: Permission = {
    resource: 'drivers',
    action: 'updatebasic',
    scope: 'all',
  };
  const editProviderPermission: Permission = {
    resource: 'drivers',
    action: 'updatebasic',
    scope: 'provider',
  };

  const canEditAll = useHasPermission(user, editAllPermission);
  const canEditProvider = useHasPermission(user, editProviderPermission);

  React.useEffect(() => {
    setCanEditDriver(canEditAll || canEditProvider);
  }, [canEditAll, canEditProvider]);

  return canEditDriver;
};
